import type { UnityInstance } from "./unity";

export type AccountAction = "register" | "login" | "logout" | "delete" | "send_verification";

export interface AccountCommand {
  action: AccountAction;
  email: string;
  password: string;
}

export interface AccountResult {
  success: boolean;
  message: string;
  isGuest: boolean;
  registrationRequired: boolean;
  emailVerified: boolean;
  emailDeliveryEnabled: boolean;
}

declare global {
  interface Window {
    superWerwolfAccountResult?: (json: string) => void;
    superWerwolfOpenAccountGate?: () => void;
  }
}

export function createAccountCommand(action: AccountAction, email: string, password: string): AccountCommand {
  if (action === "logout") return { action, email: "", password: "" };
  if (action === "send_verification") return { action, email: "", password: "" };
  if (action === "delete") {
    if (password.length === 0) throw new Error("Zum Löschen wird dein aktuelles Passwort benötigt.");
    return { action, email: "", password };
  }
  const normalizedEmail = email.trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(normalizedEmail)) {
    throw new Error("Bitte gib eine gültige E-Mail-Adresse ein.");
  }
  if (password.length === 0) throw new Error("Bitte gib dein Passwort ein.");
  if (action === "register" && password.length < 10) {
    throw new Error("Das Passwort braucht mindestens 10 Zeichen.");
  }
  return { action, email: normalizedEmail, password };
}

export function sendAccountCommand(instance: UnityInstance | undefined, command: AccountCommand): void {
  if (!instance?.SendMessage) throw new Error("Das Spiel wird noch geladen. Bitte gleich erneut versuchen.");
  instance.SendMessage("SuperWerwolfSession", "SubmitAccountAction", JSON.stringify(command));
}

export function parseAccountResult(json: string): AccountResult {
  const value: unknown = JSON.parse(json);
  if (typeof value !== "object" || value === null) throw new Error("Ungültige Accountantwort.");
  const result = value as Partial<AccountResult>;
  if (typeof result.success !== "boolean" || typeof result.message !== "string" ||
      typeof result.isGuest !== "boolean" || typeof result.registrationRequired !== "boolean" ||
      typeof result.emailVerified !== "boolean" || typeof result.emailDeliveryEnabled !== "boolean") {
    throw new Error("Unvollständige Accountantwort.");
  }
  return result as AccountResult;
}
